import React from 'react';
import { SpinnerWrapper, StyledSpinner } from './SidewideSearch.styles';

interface SpinnerProps {
  size?: number | undefined;
}

const Spinner: React.FC<SpinnerProps> = ({ size }) => {
  return (
    <SpinnerWrapper>
      <StyledSpinner size={size} data-testid="spinner" />
    </SpinnerWrapper>
  );
};

export default Spinner;
